import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from "app/store";
import { CalloutDto } from "generated/CoreApi_v1";
import { coreApiV1 } from "providers/CoreApiProvider";

export type CalloutHash = Record<string, boolean>;

// Estado que será utilizado pelo REDUCER
interface CalloutState {
    error: ApiProblemErrors | null;
    knowledgeCallouts: CalloutDto[];
    lmsCallouts: CalloutDto[];
    foundationCallouts: CalloutDto[];
}

// Estado Inicial
const initialState: CalloutState = {
    error: null,
    knowledgeCallouts: [],
    lmsCallouts: [],
    foundationCallouts: []
};

// Cria Reducer's através de SLICE.
const calloutSlice = createSlice({
    name: 'callouts',
    initialState,
    reducers: {
        updateKnowledgeCallouts: (state, action: PayloadAction<CalloutDto[]>) => {
            action.payload.forEach((item) => {
                var x = state.knowledgeCallouts.find(p => p.id == item.id);
                if (x == null) state.knowledgeCallouts.push(item);
                else x.active = item.active;
            });
        },
        updateLmsCallouts: (state, action: PayloadAction<CalloutDto[]>) => {
            action.payload.forEach((item) => {
                var x = state.lmsCallouts.find(p => p.id == item.id);
                if (x == null) state.knowledgeCallouts.push(item);
                else x.active = item.active;
            });
        },
        updateFoundationCallouts: (state, action: PayloadAction<CalloutDto[]>) => {
            action.payload.forEach((item) => {
                var x = state.foundationCallouts.find(p => p.id == item.id);
                if (x == null) {
                    state.foundationCallouts.push(item);
                }
                else {
                    x.active = item.active;
                    x.total = item.total;
                }
            });
        }
    },
    extraReducers: (builder) => {
        ///
        builder.addCase(fetchKnowledgeCallout.fulfilled, (state, { payload }) => {
            state.knowledgeCallouts = payload;
            state.error = null;
        });
        builder.addCase(fetchLmsCallout.fulfilled, (state, { payload }) => {
            state.lmsCallouts = payload;
            state.error = null;
        });
        builder.addCase(fetchFoundationCallout.fulfilled, (state, { payload }) => {
            state.foundationCallouts = payload;
            state.error = null;
        });
    }
});

export const { updateKnowledgeCallouts, updateLmsCallouts, updateFoundationCallouts } = calloutSlice.actions;

export default calloutSlice.reducer;

//#region Selectors

export const CurrentKnowledgeCallouts = (state: RootState) => state.callouts.knowledgeCallouts;

export const CurrentLmsCallouts = (state: RootState) => state.callouts.lmsCallouts;

export const CurrentFoundationCallouts = (state: RootState) => state.callouts.foundationCallouts;

//#endregion


//#region Async Thunk

//async function x() {

//    //const result = await coreApiV1.knowledgeQuickAccess.getQuickAccessList(p);
//    let myhash: CalloutHash = {};
//    myhash[FeedType[FeedType.Startup]] = true;
//    return myhash;

//};

export const fetchKnowledgeCallout = createAsyncThunk<CalloutDto[], {}, { rejectValue: ApiProblemErrors; }>
    ("callout/knowledgeCallouts", async (p, thunkApi) => {
        try {
            const result = await coreApiV1.knowledgeSettings.getKnowledgeCallouts({});
            return result.data;
        }
        catch (e) {
            return thunkApi.rejectWithValue(e as ApiProblemErrors);
        }
    });

export const fetchLmsCallout = createAsyncThunk<CalloutDto[], {}, { rejectValue: ApiProblemErrors; }>
    ("callout/lmsCallouts", async (p, thunkApi) => {
        try {
            const result = await coreApiV1.lmsSettings.getLmsCallouts({});
            return result.data;
        }
        catch (e) {
            return thunkApi.rejectWithValue(e as ApiProblemErrors);
        }
    });

export const fetchFoundationCallout = createAsyncThunk<CalloutDto[], {}, { rejectValue: ApiProblemErrors; }>
    ("callout/foundationCallouts", async (p, thunkApi) => {
        try {
            const result = await coreApiV1.foundationSettings.getFoundationCallouts({});
            return result.data;
        }
        catch (e) {
            return thunkApi.rejectWithValue(e as ApiProblemErrors);
        }
    });

//#endregion
